export const covisageConstants = {
    CARDS_SHUFFLED: 'COVISAGE_CARDS_SHUFFLED',
    DELETE_CARD: 'COVISAGE_DELETE_CARD',
    SET_CARD_NOTE: 'COVISAGE_SET_CARD_NOTE',
    SET_ROOMS: 'COVISAGE_SET_ROOMS',
    SET_SLIDER: 'COVISAGE_SET_SLIDER',
    SET_USER: 'COVISAGE_SET_USER',
    STATE_CHANGED: 'COVISAGE_STATE_CHANGED',
}
